// extracted by mini-css-extract-plugin
export var measureBox = "_bj-0";